/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';
export let scrollto:any[] = [()=> {
    class ScrollToDirective {
        restrict = 'A';
        scope = {
            trigger: '=scrollto'
        };

        link(scope, element) {
            scope.$watch('trigger', function (value) {
                if (value) {
                    var y = $(element).position().top;
                    var modal = $(element).parents('.fancybox-wrap, .fancybox-skin');

                    if (modal.size()) {
                        modal.animate({
                            scrollTop: y
                        }, 1000);
                    } else {
                        $('html').animate({
                            scrollTop: y
                        }, 1000);
                    }

                    scope.trigger = false;
                }
            });
        }
    }

    return new ScrollToDirective();
}];


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/scroll-to.directive.ts